// eslint-disable-next-line import/prefer-default-export
export const EmployeeBidProfileWarningType = Object.freeze({
    SchedulePatternAdded: 0,
    SchedulePatternRemoved: 1,
});
